import React from "react";
import blogImage from "./blogimage.png";
import icon from "./greg.jpg";
import "./App.css";

function App() {
  const styles = {
    backgroundImage: `url(${blogImage})`,
    height: "200px",
    width: "100%",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  };

  return (
    <div className="card">
      <div className="img" style={styles}></div>
      <div className="course">
        <b>Learning</b>
        <p>Published 21 Dec 2023</p>
        <h2>HTML & CSS FOUNDATIONS</h2>
        <p className="about">
          These languages are the backbones of every website, defining
          structure, content and presentation
        </p>
      </div>
      <div className="user-details">
        <img src={icon} alt="A picture of Greg Hooper" className="user-icon" />
        <span>Greg Hooper</span>
      </div>
    </div>
  );
}

export default App;
